import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigProvider } from "antd";
import App from './App';
import viVN from "antd/locale/vi_VN";
import "@ant-design/v5-patch-for-react-19";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
reportWebVitals();
